export const INTL_RESOURCE = 'page.quotes.request.view';
export const SEARCH_PARAM_CONFIRMATION_MODAL = 'confirmation-modal';
export const SEARCH_PARAM_STATUS = 'status';

export const replacementImageUrl = '/images/userPlaceholderImg.png';
